/**
 * Mirrors Maksym's SQL audience filter:
 *   REPLACE(username, '_', '.') = LOWER(REGEXP_REPLACE(SPLIT(email, '@')[0], '\\+.*$', ''))
 *
 * Returns true if the username matches the email's local part after:
 *   - stripping the +alias suffix from the email local part
 *   - replacing underscores with dots in the username
 *   - case-insensitive comparison
 */
export function isUsernameSimilarToEmail(
  username: string,
  email: string
): boolean {
  if (!username || !email) {
    return false;
  }

  const [localPart] = email.split('@');
  if (!localPart) {
    return false;
  }

  const normalizedEmail = localPart.replace(/\+.*$/, '').toLowerCase();
  const normalizedUsername = username.replace(/_/g, '.').toLowerCase();

  return normalizedUsername === normalizedEmail;
}
